module.exports = __webpack_public_path__ + "static/media/leadFunnel.6843d826.png";